var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSliders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2C8.27614 2 8.5 2.22386 8.5 2.5V3.82247C9.22287 4.03761 9.75 4.70724 9.75 5.5C9.75 6.29276 9.22287 6.96239 8.5 7.17753V13.5C8.5 13.7761 8.27614 14 8 14C7.72386 14 7.5 13.7761 7.5 13.5V7.17753C6.77713 6.96239 6.25 6.29276 6.25 5.5C6.25 4.70724 6.77713 4.03761 7.5 3.82247V2.5C7.5 2.22386 7.72386 2 8 2ZM8 6.25C8.41421 6.25 8.75 5.91421 8.75 5.5C8.75 5.08579 8.41421 4.75 8 4.75C7.58579 4.75 7.25 5.08579 7.25 5.5C7.25 5.91421 7.58579 6.25 8 6.25Z",
    fill: "#1E4841"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 2C12.7761 2 13 2.22386 13 2.5V8.82247C13.7229 9.03761 14.25 9.70724 14.25 10.5C14.25 11.2928 13.7229 11.9624 13 12.1775V13.5C13 13.7761 12.7761 14 12.5 14C12.2239 14 12 13.7761 12 13.5V12.1775C11.2771 11.9624 10.75 11.2928 10.75 10.5C10.75 9.70724 11.2771 9.03761 12 8.82247V2.5C12 2.22386 12.2239 2 12.5 2ZM12.5 11.25C12.9142 11.25 13.25 10.9142 13.25 10.5C13.25 10.0858 12.9142 9.75 12.5 9.75C12.0858 9.75 11.75 10.0858 11.75 10.5C11.75 10.9142 12.0858 11.25 12.5 11.25Z",
    fill: "#1E4841"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 2C3.77614 2 4 2.22386 4 2.5V6.82247C4.72287 7.03761 5.25 7.70724 5.25 8.5C5.25 9.29276 4.72287 9.96239 4 10.1775V13.5C4 13.7761 3.77614 14 3.5 14C3.22386 14 3 13.7761 3 13.5V10.1775C2.27713 9.96239 1.75 9.29276 1.75 8.5C1.75 7.70724 2.27713 7.03761 3 6.82247V2.5C3 2.22386 3.22386 2 3.5 2ZM3.5 9.25C3.91421 9.25 4.25 8.91421 4.25 8.5C4.25 8.08579 3.91421 7.75 3.5 7.75C3.08579 7.75 2.75 8.08579 2.75 8.5C2.75 8.91421 3.08579 9.25 3.5 9.25Z",
    fill: "#1E4841"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliders);
export default __webpack_public_path__ + "static/media/sliders.818d859c19983dde82008fdbe5aa507c.svg";
export { ForwardRef as ReactComponent };